<template>
  <div class="app-root">
    <input type="checkbox" id="sidebar-toggle" class="sidebar-toggle-input" v-if="usuario" />
    <encabezado-component v-if="usuario" :usuario="usuario" :permisos="sesion.permisos()" @cierre="olvidarSesion" />
    <label for="sidebar-toggle" class="sidebar-overlay" v-if="usuario"></label>
    <div class="app-main" :class="{ 'con-sidebar': usuario }">
      <header class="app-topbar" v-if="usuario">
        <div class="topbar-left">
          <label for="sidebar-toggle" class="sidebar-toggle">
            <b-icon icon="menu" />
          </label>
          <h1>{{ tituloPagina }}</h1>
        </div>
        <div class="topbar-right">
          <router-link class="topbar-user" :to="{ name: 'PerfilComponent' }">
            <b-icon icon="account-circle" size="is-medium" />
            <span>{{ usuario.usuario }}</span>
          </router-link>
        </div>
      </header>
      <main class="app-content">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
  import EncabezadoComponent from './components/EncabezadoComponent'
  import HttpService from './Servicios/HttpService'
  import AyudanteSesion from './Servicios/AyudanteSesion'

  const TITULOS = {
    InicioComponent: 'Inicio',
    ProductosComponent: 'Inventario',
    AgregarProducto: 'Agregar producto',
    EditarProducto: 'Editar producto',
    MarcasCategorias: 'Marcas y categorías',
    AlmacenesComponent: 'Almacenes',
    AgregarAlmacen: 'Agregar almacén',
    EditarAlmacen: 'Editar almacén',
    ReconciliacionInventario: 'Reconciliación de inventario',
    RealizarVenta: 'Realizar venta',
    ReporteVentas: 'Reporte de ventas',
    ReporteCuentas: 'Reporte de cuentas',
    ReporteApartados: 'Reporte de apartados',
    ReporteCotizaciones: 'Reporte de cotizaciones',
    DeliveriesComponent: 'Deliveries',
    ChoferesComponent: 'Choferes',
    EditarChofer: 'Editar chofer',
    HistorialComponent: 'Movimientos',
    ProveedoresComponent: 'Proveedores',
    AgregarProveedor: 'Agregar proveedor',
    EditarProveedor: 'Editar proveedor',
    RealizarPago: 'Registrar pago',
    PagosComponent: 'Pagos',
    CierresComponent: 'Cierre de caja',
    ClientesComponent: 'Clientes',
    AgregarCliente: 'Agregar cliente',
    EditarCliente: 'Editar cliente',
    MetodosComponent: 'Métodos de pago',
    AgregarMetodo: 'Agregar método',
    EditarMetodo: 'Editar método',
    UsuariosComponent: 'Usuarios',
    AgregarUsuario: 'Agregar usuario',
    EditarUsuario: 'Editar usuario',
    PerfilComponent: 'Mi perfil',
    CambiarPassword: 'Cambiar contraseña',
    RolesComponent: 'Roles',
    AgregarRol: 'Agregar rol',
    EditarRol: 'Editar rol',
    AbonosComponent: 'Abonos',
    RealizarAbono: 'Realizar abono',
    EditarAbono: 'Editar abono',
    EditarVenta: 'Editar venta',
    EditarCuenta: 'Editar cuenta',
  }

  export default {
    name: 'App',

    components: {
      EncabezadoComponent,
    },

    data: () => ({
      usuario: null,
      permisos: null,
      sesion: AyudanteSesion,
    }),

    computed: {
      tituloPagina() {
        return TITULOS[this.$route.name] || this.$route.name || 'Inicio'
      },
    },

    mounted() {
      this.obtenerUsuario()
    },

    methods: {
      async obtenerUsuario() {
        const { usuario, permisos } = await HttpService.obtenerConConsultas('usuarios.php', {
          accion: 'estado_autenticacion'
        })

        this.usuario = usuario
        this.permisos = JSON.parse(permisos)
      },

      olvidarSesion() {
        this.usuario = null
        this.permisos = null
        this.$router.push({ name: 'InicioSesionComponent' })
      },

      extraerDatos() {
        return {
          usuario: this.usuario,
          permisos: this.permisos,
        }
      }
    },
  }
</script>
